<!--
 * @Description: 快捷入口
 * @Author: xiawenlong
 * @Date: 2021-04-22 19:49:49
 * @LastEditors: xiawenlong
 * @LastEditTime: 2021-05-14 15:56:14
-->
<template>
  <div class="card enter">
    <div class="header">
      <div class="avatar">
        <img :src="userInfo.headPic" alt="" />
      </div>
      <div class="nickname">{{ userName }}</div>
      <div v-if="superAdminDetail.superAdmin" class="identity">超级管理员</div>
      <div v-else class="identity">管理员</div>
      <div class="tel">{{ userInfo.phone }}</div>
      <div class="email">{{ userInfo.email }}</div>
    </div>
    <div class="content">
      <div class="shortcut clearfix">
        <div class="title">快捷入口</div>
        <!-- <div class="help" @click="helpManual">帮助手册</div> -->
        <ul v-if="menuList && menuList.length !== 0" class="clearfix">
          <li v-for="(item, index) in quickEntrance" :key="index">
            <span @click="inter(item.path)">{{ item.name }}</span>
            <img
              class="close"
              src="@/assets/common/close_icon.png"
              @click="quickEntranceDel(index)"
            />
          </li>
          <li @click="goQuick">
            <i class="el-icon-plus"></i>
            添加快捷入口
          </li>
        </ul>
      </div>
      <div class="visited">
        <div class="title">最近访问</div>
        <ul class="clearfix">
          <li v-for="(item, index) in recentVisit" :key="index" @click="inter(item.path)">
            {{ item.name }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { getCookie } from '@/utils/cookies'
export default {
  props: {
    menuList: {
      type: Array,
      default: () => [],
    },
    superAdminDetail: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      clientCode: '0a983d86-2527-5512-01a9-783cd0e1',
      recentVisit: [],
      quickEntrance: [],
      userName: getCookie('userName'),
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  created() {
    if (localStorage.getItem(this.userInfo.phone + 'visit' + this.clientCode)) {
      let list = JSON.parse(localStorage.getItem(this.userInfo.phone + 'visit' + this.clientCode))
      // 兼容旧数据：若本地已存在重复 path 的访问记录，按 path 去重保留第一个
      const seen = new Set()
      this.recentVisit = list.filter(item => {
        if (seen.has(item.path)) return false
        seen.add(item.path)
        return true
      })
    }
    if (localStorage.getItem(this.userInfo.phone + 'quickEntrance' + this.clientCode)) {
      let list = JSON.parse(
        localStorage.getItem(this.userInfo.phone + 'quickEntrance' + this.clientCode),
      )
      // 兼容旧数据：若本地已存在重复 path 的快捷入口，按 path 去重保留第一个
      const seen = new Set()
      this.quickEntrance = list.filter(item => {
        if (seen.has(item.path)) return false
        seen.add(item.path)
        return true
      })
    }
  },
  methods: {
    goQuick() {
      this.$router.push('/dashbord/quick')
    },
    quickEntranceDel(i) {
      this.quickEntrance.splice(i, 1)
      localStorage.setItem(
        this.userInfo.phone + 'quickEntrance' + this.clientCode,
        JSON.stringify(this.quickEntrance),
      )
    },
    inter(path) {
      this.$router.push(path)
    },
    async helpManual() {
      let src =
        'https://statics-saas.i-ronge.com/frontend/help-book/%E8%9E%8De%E5%AD%A6%C2%B7%E6%98%8E%E5%B8%88%E9%81%93%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C.pdf'
      // 从 URL 中提取文件后缀，保证下载后格式正确
      const a = document.createElement('a')
      a.href = src
      a.target = '_blank'
      a.download = '帮助手册'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
  },
}
</script>
<style lang="scss" scoped>
.card {
  &.enter {
    width: calc(100% - 383px);
    flex: 1;
    background: #ffffff;
    height: 285px;
    .header {
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      .avatar {
        border-radius: 50%;
        overflow: hidden;
        width: 40px;
        height: 40px;
        margin-right: 9px;
        img {
          @extend %width-height;
        }
      }
      .nickname {
        font-size: 16px;
        color: #606266;
        margin-right: 7px;
      }
      .identity {
        width: 72px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        border: 1px solid #ff7b33;
        border-radius: 3px;
        font-size: 12px;
        color: #ff7b33;
        margin-right: 40px;
      }
      .tel {
        margin-right: 30px;
      }
    }
    .content {
      padding: 10px 0 0 12px;
      .title {
        font-size: 16px;
        font-weight: 400;
        color: #606266;
        margin-bottom: 10px;
        padding: 0 8px;
      }
      ul {
        li {
          position: relative;
          cursor: pointer;
          float: left;
          width: 128px;
          height: 36px;
          background: #f2f2f2;
          border-radius: 4px;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          text-align: center;
          line-height: 36px;
          margin: 0 8px;
          margin-bottom: 12px;
          transition: all 0.3s;
          .close {
            position: absolute;
            right: -7px;
            top: -10px;
            width: 20px;
            height: 20px;
            opacity: 0;
            transition: all 0.3s;
          }
          &:hover {
            color: #ff7b33;
            .close {
              opacity: 1;
            }
          }
        }
      }
      .shortcut {
        .help {
          cursor: pointer;
          float: left;
          width: 128px;
          height: 36px;
          background: #f2f2f2;
          border-radius: 4px;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          text-align: center;
          line-height: 36px;
          margin: 0 8px;
          margin-bottom: 12px;
          transition: all 0.3s;
        }
        li {
          &:last-of-type {
            box-sizing: border-box;
            line-height: 34px;
            border: 1px solid #c2c2c2;
            border-radius: 5px;
            color: #ff7b33;
            background-color: transparent;
          }
        }
      }
    }
  }
}
</style>
